module.exports = __webpack_public_path__ + "7d4972b586d1bb5d71f70319f9ddf85f.png";